module.exports = __webpack_public_path__ + "static/EditAndDelete-27438595dad7e481645a7b9f8c6b991f.gif";